import React from "react";
import { Box, Flex, Heading } from "theme-ui";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { typography } from "@greythr/shared-components";
import { getCommonData } from "@greythr/shared-utils/regionContent";

const Logos = ({ logos }) => {
  return (
    <Box>
      <Flex sx={styles.logoContainer}>
        {logos.map(({ partnerImageAltText, partnerImage }, i) => (
          <Box key={`partner-logo-${i}`}>
            <GatsbyImage
              image={getImage(partnerImage)}
              alt={partnerImageAltText}
            />
          </Box>
        ))}
      </Flex>
    </Box>
  );
};

const PartnerLogosID = ({ awesomePartners, region }) => {
  const data = getCommonData(region)?.resellerPartners;
  return (
    <Box
      sx={{
        py: [5, 5, "7rem"],
        px: [3, 3, 4, "6.25rem"],
      }}
    >
      <Heading
        as="h2"
        sx={{
          ...typography.h2,
          mb: "4.5rem",
          textAlign: "center",
        }}
      >
        {data?.customersHeading}
      </Heading>

      <Box>
        {awesomePartners?.nodes?.length > 0 && (
          <Logos
            title="Meet few of our awesome partners"
            logos={awesomePartners.nodes}
          />
        )}
      </Box>
    </Box>
  );
};

const styles = {
  container: {
    py: [5, 5, "7rem"],
    px: [3, 3, 4, "6.25rem"],
    textAlign: "center",
  },
  logoContainer: {
    columnGap: ["0.75rem", "0.75rem", "3rem"],
    rowGap: ["1.5rem", "1.5rem", "3rem"],
    flexWrap: "wrap",
    justifyContent: "center",
  },
};

export default PartnerLogosID;
